var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('h1', [_vm._v("포인트 충전")]), _c('section', {
    staticClass: "mt-4"
  }, [_vm._m(0), _vm._m(1), _vm._m(2), _c('example-layout', {
    staticClass: "overflow-auto mt-8",
    scopedSlots: _vm._u([{
      key: "render",
      fn: function () {
        return [_c('example-charge-point')];
      },
      proxy: true
    }, {
      key: "editor",
      fn: function () {
        return [_c('prism-editor', {
          staticClass: "rounded",
          attrs: {
            "line-numbers": ""
          },
          model: {
            value: _vm.section1.exampleCode,
            callback: function ($$v) {
              _vm.$set(_vm.section1, "exampleCode", $$v);
            },
            expression: "section1.exampleCode"
          }
        })];
      },
      proxy: true
    }])
  })], 1)]);

}
var staticRenderFns = [function (){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("1. order")]), _c('p', [_vm._v("포인트 충전에 대한 주문서 관련 로직은 "), _c('b', [_vm._v("*필수")]), _vm._v("로 있어야 합니다."), _c('br'), _vm._v("시스템에 등록없이 결제된 건은 충전되지 않습니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("2. nicepay")]), _c('p', [_vm._v("나이스페이(PG, 결제대행사) 관련 로직 또한 "), _c('b', [_vm._v("*필수")]), _vm._v("로 있어야 합니다."), _c('br'), _vm._v("결제결과를 @complete 이벤트를 통해서 전달 받을 수 있습니다."), _c('br'), _vm._v("결제 완료 후 회원정보를 리로드해야 포인트변동 내용이 반영됩니다.")])]);
} /* staticRenderFnsSpliter */, function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b', [_vm._v("* 기타")]), _c('p', [_vm._v("충전금액은 주문서에 전달할때 숫자(KRW, 원화)로 전달해야 합니다."), _c('br'), _vm._v("숫자로 선작업 후 vuetify 문서에 따라 아래 예제(v-slot:selection, v-slot:item)처럼 UI 표현 방법을 변경해 주시기 바랍니다.")])]);

}]

export { render, staticRenderFns }